import {useEffect} from "react";
import {bffApi} from "../features/chat/bffApi";
import {migrateLegacyFlags} from "./featureFlags";

/**
 * One-time migration of the legacy per-browser flag keys (experimentalMode,
 * showInternalFeatures, showDebugIndicators, legacyMode) into the per-user
 * feature bitmask. The mask read path already falls back to deriving from
 * the legacy keys, so this only persists that value and cleans up.
 * This component can be safely removed after the migration period.
 */
export function FeatureFlagsMigration() {
    const {data} = bffApi.endpoints.getUser.useQuery();
    const brukerKey = data?.brukerKey;

    useEffect(() => {
        if (brukerKey !== undefined) {
            migrateLegacyFlags(brukerKey);
        }
    }, [brukerKey]);

    // Silent component - no UI
    return null;
}
